import {gql} from "apollo-angular";
import {baseResponse} from "../../../base.graphql";


export const CREATE_SERVICE_TARGET_SOCIAL_GROUP = gql`
  mutation CreateServiceTargetSocialGroupsMutation($input: ServiceTargetSocialGroupsInputObjects!) {
    createServiceTargetSocialGroupsMutation(input: $input) {
      response {
        ${baseResponse}
      }
      data {
        groupNames
      }
    }
  }
`


export const GET_INSTITUTION_SERVICES_TARGET_GROUP = gql`
  query GetInstitutionServicesTargetGroup($serviceUniqueId: String) {
    getInstitutionServicesTargetGroup(serviceUniqueId: $serviceUniqueId) {
      response {
        ${baseResponse}
      }
      data {
        groupNames
      }
    }
  }
`
